var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"m34.419 0-1.774 1.774 14.254 13.96H0v2.478h46.9L32.644 32.227 34.419 34l17.03-17.03L34.419 0Z","clipRule":"evenodd"}));
}

ArrowRightInline.defaultProps = {"width":"52","height":"34","viewBox":"0 0 52 34","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
